import firebase from "firebase/app";

import { Segment } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import markDiscussionChannelsAsRead from "astrid-firestore/src/api/discussion/markDiscussionChannelsAsRead";

import Flex from "../../../../../components/Flex/Flex";
import { useProfile } from "../../../../authentication/state/profile";
import DropdownMenu from "../../../../ui/components/DropdownMenu/DropdownMenu";
import InstantSearch from "../../../../ui/components/InstantSearch/InstantSearch";
import InstantSearchBox from "../../../../ui/components/InstantSearch/InstantSearchBox";
import InstantSearchHits from "../../../../ui/components/InstantSearch/InstantSearchHits";

import DiscussionChannelList from "../../DiscussionChannelList/DiscussionChannelList";

export default function DiscussionPortalChannelList({ discussionChannels }) {
	const { t } = useTranslation();

	const user = useProfile();

	return (
		<InstantSearch indexName="discussionChannels" configure={{ filters: `userIds:${user.id}` }}>
			<Segment vertical style={{ padding: "15px 10px 15px 15px" }}>
				<Flex>
					<InstantSearchBox transparent style={{ width: "100%" }} />

					<DropdownMenu
						options={[
							{
								text: t("markAllAsRead", "Mark all as read"),
								action: () => {
									return markDiscussionChannelsAsRead(firebase, { user, discussionChannels });
								},
							},
						]}
					/>
				</Flex>
			</Segment>

			<InstantSearchHits>
				{({ data, results }) => {
					return (
						<DiscussionChannelList
							channels={results.query ? data : discussionChannels}
							showProductionName
						/>
					);
				}}
			</InstantSearchHits>
		</InstantSearch>
	);
}
